import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductWearpart, ProductWearpartDataService } from '@vi-succ/products-domain';
import { Observable, map } from 'rxjs';
import { WearpartItem } from '../entity/wearpart';
import { environment } from '../environments/environment';
import { ProductWearpartFactory } from '../factories/product-wearpart.factory';

@Injectable({
  providedIn: 'root',
})
export class EtProductWearpartDataService implements ProductWearpartDataService {
  constructor(private http: HttpClient) {}

  getProductWearpart(salesOrg: string, language: string, materialNumber: string): Observable<ProductWearpart> {
    return this.http
      .get<WearpartItem[]>(`${environment.backend.url}/product/${salesOrg}/${language}/${materialNumber}/wearpart`)
      .pipe(map((wearparts) => ProductWearpartFactory.build(wearparts, materialNumber)));
  }
}
